import { useAppSelector } from '@/redux';

export { default as useRecaptcha } from '@/hooks/useRecaptcha';
export { default as useCurrentWeek } from '@/hooks/useCurrentWeek';

export const useDashboardTranslation = () => {
  const lang = useAppSelector((state) => state.user.language) || 'en';
  const translations = useAppSelector((state) => state.campaign.translations);

  return (key: string, fallback = '') => {
    const translation = translations?.[key];

    if (typeof translation === 'string') return translation;
    if (translation && typeof translation === 'object') {
      return translation[lang as keyof typeof translation] || fallback;
    }

    return fallback;
  };
};
